import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router';

import { TABLET_WIDTH } from '@/constants';
import {
  Avatar,
  Logo,
  Stack,
  Typography,
  useWindowSize,
} from '@data-products-and-ai/react-components';

import '@/components/Header/Header.scss';

export const Header = () => {
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const isMobile = width <= TABLET_WIDTH;
  const { accounts } = useMsal();
  const user = accounts?.[0] ?? null;

  const navigateHome = () => {
    navigate('/');
  };

  return (
    <div className="header">
      <Logo alt="SAFE Millwright" onClick={navigateHome} />
      <Typography tag="textlarge_strong" color="var(--color-neutral)">
        SAFE
      </Typography>
      <div className="header__info">
        {isMobile ? null : (
          <Stack direction="row" gap={16}>
            <Stack
              justifyContent="flex-end"
              horizontalAlign="right"
              verticalAlign="bottom"
            >
              <Typography tag="textdefault_strong" color="var(--color-neutral)">
                {user?.name}
              </Typography>
              <Typography tag="textsmall" color="var(--color-default)">
                {user?.username}
              </Typography>
            </Stack>
            <Avatar />
          </Stack>
        )}
      </div>
    </div>
  );
};
